import React from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const BOX_STYLE = {
  borderRadius: 8,
  border: "1px solid #ccc",
  padding: 40,
  maxWidth: 400,
  margin: "auto",
  textAlign: "center",
  backgroundColor: "#fff",
};

export default function confirmBox({ title, message, yesLabel = "Yes", noLabel = "No", onYes }) {
  confirmAlert({
    customUI: ({ onClose }) => (
      <div className="custom-ui" style={BOX_STYLE}>
        <h2>{title}</h2>
        {message ? <p>{message}</p> : null}
        <div style={{ marginTop: 30 }}>
          <button type="button" className="btn btn-secondary" style={{ marginRight: 15 }} onClick={onClose}>
            {noLabel}
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              onClose();
              onYes();
            }}
          >
            {yesLabel}
          </button>
        </div>
      </div>
    ),
  });
}
